import { render, staticRenderFns } from "./RenewMembershipMessage.vue?vue&type=template&id=da9aeba0"
import script from "./RenewMembershipMessage.vue?vue&type=script&lang=ts"
export * from "./RenewMembershipMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports